<template>
  <v-container
      fluid
      grid-list-lg
  >
    <v-row justify="center">
      <v-dialog persistent v-model="changeDialog" width="600px">
        <v-card>
          <v-card-title>{{ $t('MessageList.messageInformations') }}</v-card-title>
          <v-card-text>
            <v-row>
              <v-checkbox v-model="currentItem.rootMessage" :label="mainFault"/>
              <v-checkbox v-model="currentItem.messageType" true-value="WARNING" false-value="ERROR" :label="warning" class="ml-3"/>
            </v-row>
            <v-textarea v-model="currentItem.comment" :label="remarkSolution"/>
          </v-card-text>
          <v-card-actions>
            <v-spacer/>
            <v-btn text @click="changeDialog = false">{{ $t('MessageList.cancel') }}</v-btn>
            <v-btn text @click="updateMessage">{{ $t('MessageList.save') }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <v-layout row>
      <v-flex xs12 xl8 offset-xl2>
        <v-card style="margin-bottom: 10px">
          <v-card-title>{{ $t('MessageList.errorMessage') }} {{ building.buildingNumber }}</v-card-title>
          <v-card-subtitle>
            <span v-if="address != null">
              {{ address.country }} - {{ address.postalCode }} {{ address.city }}, {{ address.street }} {{ address.houseNumber }},
            </span>{{ $t('MessageList.timeOnSite') }} {{ currentTime }}
          </v-card-subtitle>
          <v-card-text>
            {{ building.description }}
          </v-card-text>
          <v-card-actions>
            <v-spacer/>
            <v-btn
                text
                @click="openBuildingContactList"
            >{{ $t('MessageList.contacts') }}
            </v-btn>
          </v-card-actions>
        </v-card>
        <v-data-table
            :headers="headers"
            :items="messages"
            class="elevation-1"
            :loading="loading"
            :search="search"
            hide-default-footer
            sort-by="timestamp"
            sort-desc
            :items-per-page="messages.length + 1"
        >
          <template v-slot:top>
            <v-toolbar flat>
              <v-text-field
                  v-model="search"
                  append-icon="mdi-magnify"
                  :label="searchFilter"
                  single-line
                  clearable
                  hide-details
              />
              <v-spacer></v-spacer>
              <v-select
                  v-model="select"
                  :items="showByLastFullMonths"
                  item-text="months"
                  item-value="value"
                  label="Zeitraum"
                  hide-details
                  return-object
                  @change="loadMessagesByMonths"
              ></v-select>
              <v-spacer></v-spacer>
              <v-btn
                  text
                  class="text--secondary hidden-xs-only"
                  :loading="excelLoading"
                  @click="openDownloadDialog">
                <v-icon>mdi-file-excel</v-icon>
                {{ $t('MessageList.exportReports') }}
              </v-btn>
            </v-toolbar>
          </template>
          <template v-slot:item.timestamp="{ item }">
            <span>{{ item.timestamp | moment("L") }} {{ item.timestamp | moment("LTS") }}</span>
          </template>
          <template v-slot:item.rootMessage="{ item }">
                        <span style="width: 70px">
                             <v-icon v-if="item.rootMessage">mdi-check</v-icon>
                        </span>
          </template>
          <template v-slot:item.action="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                    v-bind="attrs"
                    v-on="on"
                    class="mr-3"
                    v-if="item.messageType === 'ERROR' || item.messageType === 'WARNING'"
                    @click="openChangeDialog(item)">
                  mdi-pencil
                </v-icon>
              </template>
              <span>Ändern</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                    v-bind="attrs"
                    v-on="on"
                    :disabled="!item.hasRaw"
                    class="mr-3"
                    @click="$refs.viewer.init(item.uuid)">
                  mdi-email-open
                </v-icon>
              </template>
              <span>Original Nachricht öffnen</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </v-flex>
      <raw-message-viewer
          hidden
          ref="viewer">
      </raw-message-viewer>
      <building-contact-list
          hidden
          ref="buildingContactList">
      </building-contact-list>
      <a
          hidden
          ref="excellink"
          :download="'Projekt_' + building.buildingNumber + '_Auswertung.xlsx'"
          :href="excelData"/>
    </v-layout>
  </v-container>
</template>

<script>

import axios from 'axios'
import moment from 'moment'
import {blobToDataURL} from 'blob-util'
import eventBus from "@/plugins/EventBus";

export default {
  components: {
    RawMessageViewer: () => import('./RawMessageViewer'),
    BuildingContactList: () => import('./BuildingContactList')
  },
  data() {
    return {
      loading: true,
      headers: [
        {text: this.$t('MessageList.type'), value: 'messageType'},
        {text: this.$t('MessageList.time'), value: 'timestamp'},
        {text: this.$t('MessageList.number'), value: 'number'},
        {text: this.$t('MessageList.description'), value: 'text'},
        {text: this.$t('MessageList.mainFault'), value: 'rootMessage'},
        {text: '', value: 'action', sortable: false, align: 'end'}
      ],
      showByLastFullMonths: [
        {months: "Aktueller Monat", value: "0"},
        {months: "Letzter Monat", value: "1"},
        {months: "Letzte zwei Monate", value: "2"},
        {months: "Letzte drei Monate", value: "3"},
        {months: "Alle", value: "-1"}
      ],
      messages: [],
      search: '',
      building: {},
      address: {},
      select: {months: "Aktueller Monat", value: "0"},
      excelLoading: false,
      excelData: '',
      currentItem: {},
      changeDialog: false,
      valueStart: '',
      valueEnd: '',
      project: false
    }
  },
  mounted: function () {
    eventBus.$on("downloadWithAxiosProject", selectedInterval => {
      this.valueStart = selectedInterval[0].start
      this.valueEnd = selectedInterval[0].end
      this.downloadWithAxios()
    });
  },
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? this.$t('MessageList.createBuildingProject') : this.$t('MessageList.updateBuildingProject')
    },
    currentTime() {
      if(this.address != null && this.address.utcOffset != null){
        return moment().utcOffset(this.address.utcOffset / 60).locale('de').format('lll');
      }
      return moment().locale('de').format('lll');
    },
    mainFault: function () {
      return this.$t('MessageList.mainFault')
    },
    warning: function () {
      return this.$t('MessageList.warning')
    },
    remarkSolution: function () {
      return this.$t('MessageList.remarkSolution')
    },
    searchFilter: function () {
      return this.$t('MessageList.searchFilter')
    }
  },
  created() {
    this.loadMessagesByMonths();
    this.loadBuilding()
  },
  methods: {
    loadMessagesByMonths() {
      this.messages = [];
      if (this.select.value != -1) {
        axios.get('/legacy-m2m/api/message/months/?building=' + this.$route.params.buildingUuid + '&lastFullMonths=' + this.select.value)
          .then(response => {
            this.messages = this.messages.concat(response.data);
            this.loading = false
          });
      } else {
        axios.get('/legacy-m2m/api/message/all/?building=' + this.$route.params.buildingUuid)
          .then(response => {
            this.messages = this.messages.concat(response.data);
            this.loading = false
          });
      }
      axios.get('/telematics/api/record/?projectUuid=' + this.$route.params.buildingUuid + '&lastDays=' + this.select.value)
          .then(response => {
            this.messages = this.messages.concat(response.data);
            this.loading = false
          });
    },
    openChangeDialog(item) {
      this.currentItem = Object.assign({}, item);
      this.changeDialog = true
    },
    updateMessage() {
      if (!this.currentItem.entries) {
        // update old messages
        axios.put('/legacy-m2m/api/message/' + this.currentItem.uuid + '/', this.currentItem)
            .then(response => {
              this.handleUpdateResponse(response.data);
            })
      } else {
        // update new/rest messages
        axios.put('/telematics/api/record/' + this.currentItem.uuid + '/', this.currentItem)
            .then(response => {
              this.handleUpdateResponse(response.data);
            })
      }
    },
    handleUpdateResponse(item) {
      this.messages.splice(this.messages.findIndex((i) => {
        return i.uuid === this.currentItem.uuid
      }), 1, item);
      this.changeDialog = false;
      this.$store.dispatch('loadStates');
    },
    loadBuilding() {
      axios.get('/address-contact/api/building/' + this.$route.params.buildingUuid + '/')
          .then(response => {
            this.building = response.data;
            this.address = response.data.address
          });
    },
    openBuildingContactList() {
      this.$refs.buildingContactList.init(this.building.uuid)
    },
    downloadWithAxios() {
      this.excelLoading = true;
      try {
        axios.get('/legacy-m2m/api/download/' + this.building.uuid + '/excel/?start=' + this.valueStart + '&end=' + this.valueEnd,
            {responseType: 'blob'})
            .then(r => r.data)
            .then((res) => {
              blobToDataURL(res)
                  .then((b) => {
                    this.excelData = b;
                    setTimeout(() => {
                      this.$refs.excellink.click();
                    }, 200);
                    this.excelLoading = false
                  });
            })
      } catch (e) {
        this.excelLoading = false
      }
    },
    openDownloadDialog() {
      eventBus.$emit('datePickerDialogProject', true)
    }
  }
}
</script>
